import base from './base';
import links from './links';
import video from './video';

export default {
    video,
    links,
    base,
};
